/**
 * Page header with kicker, title, description, optional actions.
 */
export default function PageHeader({ icon: Icon, kicker, title, description, actions }) {
  return (
    <div className="mb-8 flex items-start justify-between gap-6 flex-wrap">
      <div>
        {kicker && (
          <div className="inline-flex items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-brand mb-1.5">
            {Icon && <Icon className="w-3.5 h-3.5" />} {kicker}
          </div>
        )}
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight">{title}</h1>
        {description && <p className="text-sm text-ink-dim mt-2 max-w-2xl">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}
